import * as firebase from 'firebase';
import * as _ from 'lodash';

import * as types from '../actionTypes';
import { fbDataPurifier } from '../utils';


export function createFleet(newFleetData, newFleetKey) {
  return (dispatch, getState) => {
    const state = getState();
    const userClient = _.get(state, 'authState.currentUser.client', null);

    if (!userClient) { return; }

    const key = newFleetKey || firebase.database().ref().push().key;

    dispatch({
      type: types.FLEET_CREATE_REQUEST,
      key,
      data: newFleetData,
    });

    firebase.database()
      .ref(`/clients/${userClient}/fleet/fleets`)
      .child(key)
      .update(fbDataPurifier(newFleetData))
      .then(() => {
        dispatch({
          type: types.FLEET_CREATE_SUCCESS,
          key,
        });
      })
      .catch((error) => {
        dispatch({
          type: types.FLEET_CREATE_FAILURE,
          key,
          error,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/Fleet/fleet.actions.js